<template>
  <div class="bottom-m">
    <div class="flex-x-y-center bottom-class">
      {{ initProjectList.site_info.icp }}
    </div>
    <div class="flex-x-y-center bottom-cl">
      <p class="apply-icp" v-html="initProjectList.site_info.address"></p>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/store/piniaStore";
export default {
  computed: {
    ...mapState(useMainStore, {
      initProjectList: "getInitProject",
    }),
  },
};
</script>

<style scoped>
.bottom-m {
  width: 80%;
  margin-left: 10%;
  height: 100px;
}
.bottom-class {
  font-size: 16px;
  font-weight: 350;
  margin-top: 50px;
  color: rgb(152, 146, 146);
}
.bottom-cl {
  font-size: 16px;
  font-weight: 350;
  margin-top: 10px;
  color: rgb(152, 146, 146);
}
</style>
